"use client";
import { jsxs as i, jsx as _ } from "react/jsx-runtime";
import t from "clsx";
import { _ as b } from "../../lodash-B7QmW1Cn.js";
import { memo as p, useState as g } from "react";
import { Box as c } from "../base/Base.js";
import '../../assets/ToggleBox.css';const u = "_box_dnion_1", v = "_darkblue_dnion_4", k = "_icon_dnion_9", N = "_title_box_dnion_13", f = "_gray_dnion_23", y = "_clean_dnion_32", w = "__active_dnion_73", B = "_title_dnion_13", T = "_content_dnion_101", j = "_content__inner_dnion_149", n = {
  box: u,
  darkblue: v,
  "darkblue-small": "_darkblue-small_dnion_4",
  icon: k,
  title_box: N,
  gray: f,
  clean: y,
  _active: w,
  title: B,
  content: T,
  content__inner: j
}, O = p(
  ({ title: a, text: l, open: s = !1, theme: o = "darkblue", children: r, ...d }) => {
    const [e, m] = g(s), x = () => {
      m(!e);
    };
    return /* @__PURE__ */ i(c, { gap: 0, className: t(n.box, n[o]), ...d, children: [
      /* @__PURE__ */ i(
        c,
        {
          gap: 12,
          row: !0,
          wide: !0,
          className: t(n.title_box, n[o], {
            [n._active]: e
          }),
          onClick: x,
          children: [
            /* @__PURE__ */ _("span", { className: t(n.title, n[o]), children: a }),
            /* @__PURE__ */ _(
              c,
              {
                center: !0,
                className: t("material-icons", n.icon, {
                  [n._active]: e
                }),
                "data-icon": b.includes(["gray", "clean"], o) ? "arrow_drop_down" : "expand_circle_down"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ _(
        "div",
        {
          className: t(n.content, n[o], {
            [n._active]: e
          }),
          children: /* @__PURE__ */ _("div", { className: t(n.content__inner, n[o]), children: l || r })
        }
      )
    ] });
  }
);
O.displayName = "ToggleBox";
export {
  O as ToggleBox
};
